import {_} from 'lodash';
import {ICustomSystemAccess} from "@component/combobox/system-role";
import {IRule} from "../../index";
import {nsRuleset} from "@component/ruleset/nsRuleset";

export namespace nsObjectSearch {

    export function getSearchUserManualPermissionRule(type: ICustomSystemAccess['type'], systemOrRoleId: number, rule: Partial<IRule> = {}): IRule {
        let _rule: IRule

        switch (type) {
            case "system": {
                _rule = nsRuleset.generateRule({
                    argument: 'True,true',
                    argumentoperator: 'Inneholder en av',
                    attribute: `[OBJECTPERMISSION;Manual;SystemId;${systemOrRoleId};true;true]`
                })
                break
            }
            case "role": {
                _rule = nsRuleset.generateRule({
                    argument: 'True,true',
                    argumentoperator: 'Inneholder en av',
                    attribute: `[OBJECTPERMISSION;Manual;SystemRoleId;${systemOrRoleId}]`
                })
                break
            }
        }

        return _.defaultsDeep(rule, _rule)
    }
}
